import React, { useState } from "react";
import ShareIcon from "../../../assets/images/icons/icon-share.svg";
import HeartIcon from "../../../assets/images/icons/icon-heart.svg";
import HeartFilledIcon from "../../../assets/images/icons/icon-heart-filled.svg";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAppConfig, setActivityIndicator } from "../../../redux/slices/appconfigSlice";
import { getLoginConfig } from "../../../redux/slices/loginconfigSlice";
import { getSearchFilters } from "../../../redux/slices/searchFilterSlice";
import { getFlightsParams, handleFavoriteHotelItem, postPunchOutAndOpenExternal } from "../../../helpers/common";
import { getBooking } from "../../../redux/slices/bookingSlice";
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import { toast } from "react-toastify";
// The package's built entry, not its untranspiled `/src` directory. Importing
// `/src` shipped raw ESM that only webpack transpiled — Jest does not transform
// node_modules, so it broke every test that touched this component's module
// graph (8 modules, including routes/index.js and App.js).
import { CopyToClipboard } from "react-copy-to-clipboard";
import PropTypes from "prop-types";
import Lottie from "lottie-react";
import MapJson from '../../../assets/images/lottieViews/map.json';
import useTranslationCustom from "../../../i18n/customHook/useTranslation";
import Expedia from "../../../assets/images/icons/expedia.svg";
import ExpediaDark from "../../../assets/images/icons/expedia-logo-dark.svg";
import { GetFlightDetailsService } from "../../../services/HotelDetailServices";
// import BackArrow from "../../../assets/images/arrow.svg";
import ShareBranchLink from "./ShareBranchLink";
import GeniusJson from "../../../assets/images/lottieViews/genius.json";
import BulbJson from "../../../assets/images/lottieViews/bulb.json";
import { isMobile, isTablet } from "react-device-detect";
import { buildShareLink } from "../../../utils/webShareLink";
import { getBackTarget, getDetailPath, getDetailUrl, getShareLandingIdx } from "../../../utils/detailUrl";

const TopBar = ({
    isMap = false,
    flightRef = null,
    headerRef = null,
    handleMapBackClick = null,
    normalComponent = false,
    gallery = false
}) => {
    const { T } = useTranslationCustom();
    const prevUrl = localStorage.getItem('prevUrl');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const booking = useSelector(getBooking);
    const { room, flight } = booking;
    const { selectedHotel, selectedHotelToShare } = useSelector(getSearchFilters);
    const appconfig = useSelector(getAppConfig);
    const loginconfig = useSelector(getLoginConfig);
    const searchfilters = useSelector(getSearchFilters);
    const [shortLink, setShortLink] = useState("");

    // The canonical detail URL, not window.location: the address bar is swapped
    // for the share URL once the package details API resolves.
    // Parsed once, defensively: getDetailUrl() returns "" before anything has
    // been captured, and `new URL("")` throws during render — with no
    // ErrorBoundary in the tree that would blank the whole page.
    const detailParams = (() => {
        try {
            return new URL(getDetailUrl()).searchParams;
        } catch {
            return new URLSearchParams();
        }
    })();
    const isFav = detailParams.get("fav") === 'true';
    const isChatOffer = detailParams.get("chatOffer") === 'true';
    const flightNumbersStringFromUrl = detailParams.get("flightNumbersString");

    const createLink = () => {
        // Package sharing now uses a web-based link with the shared package
        // (selectedHotelToShare) embedded as a compressed token, instead of a
        // Branch short link. The host is captured dynamically from
        // window.location, so the link is always built for the current origin.
        setShortLink(buildShareLink(selectedHotelToShare, flight));

        // --- Previous Branch short link generation (kept for reference) ---
        // const getURL = AppConfig.baseApiURL.includes('staging')
        //     ? 'https://staging.genius.travel/'
        //     : 'https://genius.travel/';
        //
        // const linkData = {
        //     campaign: 'genius/package',
        //     data: {
        //         payload: JSON.stringify(selectedHotelToShare),
        //         '$ios_url': getURL,
        //         '$ios_url_xx': getURL,
        //         // '$ipad_url': getURL,
        //
        //         '$android_url': getURL,
        //         '$android_url_xx': getURL,
        //         // '$android_deeplink_path': 'geniustravel://',
        //
        //         '$web_only': true, // This will always open the web URL, even on mobile devices
        //         '$fallback_url': getURL,
        //
        //         '$og_title': selectedHotelToShare?.name,
        //         '$og_description': `★ ${selectedHotelToShare?.starRating} • ${selectedHotelToShare?.address}`,
        //         '$og_image_url': selectedHotelToShare?.thumbnailUrl
        //     }
        // };
        //
        // branch.link(linkData, function (err, link) {
        //     setShortLink(link);
        // });
    }

    const handleOnBooking = () => {
        const params = getFlightsParams(
            room,
            searchfilters,
            loginconfig,
            booking,
            appconfig,
            searchfilters?.selectedHotel?.id,
            searchfilters?.selectedHotel?.guidForBooking,
            isFav,
            isChatOffer
        );
        const BaseUrl = window.location.origin;
        const newTab = window.open(`${BaseUrl}/fetching`, '_blank');

        try {
            params.GetFinalExpediaUrl = true;
            params.transaction_id = appconfig?.transaction_id;

            // console.log(JSON.stringify(params), "params for getting more flights");

            dispatch(setActivityIndicator(true));
            GetFlightDetailsService(params)
                .then((_flightDetails) => {
                    dispatch(setActivityIndicator(false));

                    // console.log({_flightDetails});

                    if (
                        _flightDetails?.warnings?.length &&
                        _flightDetails?.warnings[0]?.code === "400.19"
                    ) {
                        toast.info(_flightDetails?.warnings[0]?.description);
                        return;
                    }

                    const externalUrl = _flightDetails?.offers[0]?.links?.webDetails?.href;
                    postPunchOutAndOpenExternal({
                        url: externalUrl,
                        transactionId: appconfig?.transaction_id,
                        guid: searchfilters?.selectedHotel?.guidForBooking,
                        dispatch,
                        setActivityIndicator,
                        existingTab: newTab,
                    });
                })
                .catch(() => {
                    dispatch(setActivityIndicator(false));
                    if (newTab) {
                        newTab.close();
                    }
                });
        } catch {
            if (newTab) {
                newTab.close();
            }
        }
    };

    const splitString = (input) => {
        const regex = /\b(or|of)\b/i; // Matches "or" or "of" as whole words, case-insensitively
        const match = input.match(regex);
        if (match) {
            const index = match.index;
            // const word = match[0];
            // Split the string into two parts: before and after the matched word (inclusive)
            const before = input.slice(0, index).trim();
            const after = input.slice(index).trim();
            return [before, after]; // Keep the word and the text after it together
        }
        // Return the input as a single element if no match
        return [input];
    }

    function handleClick(index) {
        if (index === 0) {
            handleOnBooking();
        } else {
            flightRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    // Every branch except branchData returned true, so this collapses cleanly.
    const shouldReplace = () => !appconfig?.branchData;

    // React Router stamps an incrementing `idx` on every history entry it pushes.
    // idx 0 (or a missing state, e.g. a direct load) means there is nothing to pop
    // back to, so navigate(-1) would be a no-op.
    const canGoBack = () => {
        if (typeof window === 'undefined') {
            return false;
        }
        const idx = window.history.state?.idx;
        if (typeof idx !== 'number') {
            return window.history.length > 1;
        }
        if (idx <= 0) {
            return false;
        }
        // The entry behind us can be the share link this session was opened with.
        // Popping onto it lands on /link, which renders this same detail page once
        // a detail session exists — and the address bar already shows that URL, so
        // the click would look like it did nothing.
        const landingIdx = getShareLandingIdx();
        return landingIdx === null || idx - 1 > landingIdx;
    }

    const goBack = () => {
        if (canGoBack()) {
            navigate(-1);
        } else {
            navigate('/', { replace: true });
        }
    }

    const getType = () => {
        if (appconfig?.branchData) {
            return 'branch';
        } else if (isFav) {
            return 'fav';
        } else if (isChatOffer) {
            return 'chatOffer';
        } else {
            return 'normal';
        }
    }

    const handleBackClick = () => {
        if (normalComponent && gallery) {
            // Back to the readable detail URL captured before the
            // address bar was swapped for the share URL. Popping
            // history instead would land on the share URL, which
            // rebuilds the package from scratch via Home.
            navigate(getDetailPath(), { replace: true });
            return;
        }
        if (normalComponent) {
            goBack();
            return;
        }
        if (isMap && handleMapBackClick) {
            handleMapBackClick();
            return;
        }
        // prevUrl is the share link itself when this session was opened from
        // one, which would just re-render this page — getBackTarget maps that
        // (and a missing prevUrl) to "/".
        navigate(getBackTarget(prevUrl), { replace: true });
    }

    // Keyboard equivalent of the click. The element stays a <div> so the
    // existing .left-action styling is untouched; role + tabIndex give it the
    // button semantics it was missing, and Enter/Space activate it the way a
    // real button would.
    // splitString returns one element when the translated string has no
    // "or"/"of" (the regex is English-only), so index [1] is undefined in nl/de.
    const expediaTextParts = splitString(
        T('Packages_Detail:Top_Bar_Direct_Expedia') || ''
    ).filter(Boolean);

    const handleBackKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            handleBackClick();
        }
    }

    return (
        <div id="topBar" className="topbar-wrapper" ref={headerRef}>
            <div className="container">
                <div className={isMap ? '' : 'content-holder'}>
                    <div
                        className="left-action"
                        role="button"
                        tabIndex={0}
                        aria-label={T("Buttons:Back")}
                        onClick={handleBackClick}
                        onKeyDown={handleBackKeyDown}
                    >
                        {!isMap && isChatOffer && !gallery ? (
                            <div className="">
                                <a className="animated-back-btn">
                                    <Lottie animationData={GeniusJson} loop={true} className='genius-animation' />
                                    <Lottie animationData={BulbJson} loop={true} className='bulb-animation' />
                                    <span>{T("Buttons:Button_Chat_Ai")}</span>
                                </a>
                            </div>
                        ) : <a>{T("Buttons:Back")}</a>}
                    </div>

                    {!isMap && <div className={'expedia-section'}>
                        {!gallery && (<div>
                            {/* role/tabIndex rather than <button>: these keep the
                                existing <p> styling, and the primary booking CTA
                                was previously unreachable by keyboard.
                                Each part renders only when splitString actually
                                produced it — the regex is English-only, so the
                                second part is undefined in nl/de and used to
                                render an empty but still clickable paragraph. */}
                            {expediaTextParts.map((part, index) => (
                                <p
                                    key={part}
                                    role="button"
                                    tabIndex={0}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        handleClick(index);
                                    }}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                                            e.preventDefault();
                                            handleClick(index);
                                        }
                                    }}
                                >
                                    {part}
                                </p>
                            ))}
                        </div>)}
                        <img
                            src={loginconfig.darkMode ? Expedia : ExpediaDark}
                            alt={"expedia"}
                        />
                    </div>}

                    {!isMap && <div className="right-action">
                        <ul>
                            {!gallery && (
                                <li>
                                    <a
                                        rel="noopener noreferrer"
                                        className="show-map-link"
                                        onClick={() => {
                                            // Pass the selected flight (state.booking.flight) + its hotelId
                                            // through router state so the map can restore the exact flight/
                                            // price — the booking slice is reset when this page unmounts.
                                            navigate(`/hotel/${selectedHotel?.id}/map/${getType()}`, {
                                                replace: shouldReplace(),
                                                state: { isChatOffer, flight, flightHotelId: selectedHotel?.id, flightNumbersStringFromUrl },
                                            });
                                        }}
                                    >
                                        <Lottie animationData={MapJson} loop={true} className='map_animation' />
                                        <span>{T("Packages_Detail:Show_On_Map")}</span>
                                    </a>
                                </li>)}
                            {!gallery && (
                                <li>
                                    <Dropdown className="share-button" onToggle={createLink}>
                                        <Dropdown.Toggle>
                                            <img src={ShareIcon} alt={"share-icon"} />
                                            {!(isMobile || isTablet) && T("Buttons:Share")}
                                        </Dropdown.Toggle>
                                        {shortLink &&
                                            <Dropdown.Menu>
                                                <h6>{T("Packages_Detail:Copy_To_Clipboard")}</h6>
                                                <div className="d-flex">
                                                    <input
                                                        readOnly={true}
                                                        type="text"
                                                        id="urlField"
                                                        aria-label={T("Packages_Detail:Copy_To_Clipboard")}
                                                        value={shortLink}
                                                    ></input>
                                                    <CopyToClipboard
                                                        text={`${T('Packages_Detail:Text_With_Shared_Link')}\n\n${shortLink}\nGenius`}
                                                        onCopy={() => {
                                                            toast.success(`${T("Packages_Detail:Link_Copied")}`);
                                                        }}>
                                                        <button id="copyButton">
                                                            <FontAwesomeIcon icon={faCopy} />
                                                        </button>
                                                    </CopyToClipboard>
                                                </div>
                                                <div>
                                                    <ShareBranchLink shortLink={shortLink} />
                                                </div>
                                            </Dropdown.Menu>
                                        }
                                    </Dropdown>
                                </li>)}
                            <li>
                                <a
                                    role="button"
                                    tabIndex={0}
                                    aria-pressed={!!selectedHotel?.favoriteGuid}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                                            e.preventDefault();
                                            handleFavoriteHotelItem(
                                                loginconfig,
                                                dispatch,
                                                searchfilters,
                                                searchfilters?.selectedHotel,
                                                appconfig,
                                                null,
                                                null,
                                                booking?.flight
                                            );
                                        }
                                    }}
                                    onClick={() =>
                                        handleFavoriteHotelItem(
                                            loginconfig,
                                            dispatch,
                                            searchfilters,
                                            searchfilters?.selectedHotel,
                                            appconfig,
                                            null,
                                            null,
                                            booking?.flight
                                        )
                                    }
                                >
                                    <img
                                        src={
                                            selectedHotel?.favoriteGuid ? HeartFilledIcon : HeartIcon
                                        }
                                        alt={"heart-icon"}
                                    />
                                    {selectedHotel?.favoriteGuid
                                        ? T("Buttons:Saved")
                                        : T("Buttons:Save")}
                                </a>
                            </li>
                        </ul>
                    </div>}
                </div>
            </div>
        </div>
    );
};

TopBar.propTypes = {
    isMap: PropTypes.bool,
    normalComponent: PropTypes.bool,
    flightRef: PropTypes.any,
    headerRef: PropTypes.any,
    handleMapBackClick: PropTypes.func,
    gallery: PropTypes.bool
}

export default TopBar;
